<template>
    <div>
        <Collapse v-model="value" simple style="border:0">
            <Panel name="1" hide-arrow style="margin: 20px 0;border:0" >
                <FormTitle :titleText="$t('Human_Resource_Data')"/><!-- 人事信息 -->
                <div slot="content" style="margin-top: 40px;">
                    <Form :label-width="160" label-position="left">
                        <Row :gutter="100">
                            <Col :xs="24" :sm="24" :md="12" :lg="12">
                                <FormItem :label="$t('Effective_Join_Date')"><!-- 有效雇佣日 -->
                                    <DatePicker v-model="formItem.hirevalid" type="date" disabled></DatePicker>
                                </FormItem>
                            </Col>
                            <Col :xs="24" :sm="24" :md="12" :lg="12">
                                <FormItem :label="$t('Probation_End_Date')"><!-- 试用期结束日 -->
                                    <DatePicker v-model="formItem.probationenddate" type="date" disabled></DatePicker>
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                </div>
                
            </Panel>
            <div class="btnfooter">
                <slot name="slot1"></slot>
            </div>
        </Collapse>
        <Spin size="large" fix v-if="spinShow"></Spin>
    </div>
</template>

<script>
import axios from 'axios'
import DateUtil from "@/util/DateUtil";
export default {
    data(){
        return{
            date: new DateUtil(),
            formItem:{},
            list:[],
            value:[1],
            id:'',
            serialnumber:'',
            spinShow:false
        }
    },
    methods:{
         getData(val){
            this.spinShow=true
            val?this.serialnumber=val:this.serialnumber=JSON.parse(sessionStorage.getItem("userInfo")).serialnumber
            axios.post("/employeeInformation/getEmployeeInformation", {serialnumber:this.serialnumber}).then((res) => {
                this.spinShow=false
                if (res) {
                   this.formItem=res
                }
            })
        },
    }
}
</script>

<style lang="less" scoped>
.btnfooter {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/process/files/components/PersonnelInformation.vue